import { SEO } from '../../utils/seo';
import Header from './components/Header';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Solution from './components/Solution';
import Services from './components/Services';
import SystemFlow from './components/SystemFlow';
import AutomationTable from './components/AutomationTable';
import BeforeAfter from './components/BeforeAfter';
import Process from './components/Process';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import AmazonAutomationCTA from './components/AmazonAutomationCTA';

export default function Home() {
  const siteUrl = 'https://superspoon.net';
  
  const schema = {
    '@type': 'Organization',
    name: 'スーパースプーン',
    url: 'https://superspoon.net',
    description: '年商300万〜5,000万の中小EC向け業務設計×自動化コンサルティング',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '平井',
      addressLocality: '堺市中区',
      addressRegion: '大阪府',
      addressCountry: 'JP'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 34.5733,
      longitude: 135.4825
    },
    areaServed: 'JP',
    serviceType: ['EC自動化', '業務効率化', '在庫管理', '利益計算'],
    priceRange: '¥¥'
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="スーパースプーン｜EC運営を1日5分に｜中小EC自動化コンサル"
        description="年商300万〜5,000万の中小EC向け業務設計×自動化コンサルティング。仕入れ・利益計算・出品データ・在庫同期を回る仕組みにまとめ、EC運営を1日5分に。楽天・Amazon・自社EC・eBay対応。無料相談受付中。"
        keywords="EC自動化,中小EC,業務効率化,在庫管理,利益計算,大阪,堺市"
        path="/"
        schema={schema}
      />
      <Header />
      <main>
        <Hero />
        <Problems />
        <Solution />
        <Services />
        <AmazonAutomationCTA />
        <SystemFlow />
        <AutomationTable />
        <BeforeAfter />
        <Process />
        <Pricing />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
